/* @flow */
import * as React from 'react';
import CenteredContainer from 'components/CenteredContainer';
import EventTracking from 'lib/EventTracking';
import FreeClassLimitsLearnMoreDialog from 'groups/components/FreeClassLimitsLearnMoreDialog';
import Icon from 'components/Icon';
import Link from 'components/Link';
import ModalTrigger from 'components/ModalTrigger';
import TitleHeader from 'components/TitleHeader';

export default function LimitedStreamPlaceholder(props: { peopleListUrl: string }) {
  return (
    <CenteredContainer>
      <TitleHeader
        title="You cannot send announcements to this class"
        size="small"
        flush
        icon={<Icon name="megaphone-off" color="thunder" size="xxlarge" />}
        action={
          <ModalTrigger
            onClick={() =>
              EventTracking.trackKey('free_product_limits.message_thread.learn_more.click')
            }
            modal={
              <FreeClassLimitsLearnMoreDialog
                peopleListUrl={props.peopleListUrl}
                onRequestHide={() => {}}
                uiContext="thread"
              />
            }>
            <Link weight="semibold">Learn more</Link>
          </ModalTrigger>
        }
      />
    </CenteredContainer>
  );
}
